import { useState } from "react";
import { IconMail, IconCheck, IconArrowLeft } from "@tabler/icons-react";
import React from "react";

export default function UserLogin() {
    const [email, setEmail] = useState<string>("");
    const [pending, setPending] = useState<boolean>(false);
    const [status, setStatus] = useState<string>("email");

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPending(true);
        if (!email) {
            setPending(false);
            alert("Zadajte svoj e-mail");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_PATH}/api/user/email?email=${email}`);

            if (!response.ok) {
                throw new Error("Failed to send login request");
            }

            setStatus('confirm')
            setPending(false);

        } catch (error) {
            console.error("Error during login:", error);
            alert("Nastala chyba pri prihlasovaní. Skúste to prosím znova.");
            setPending(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
            {/* Header */}
            <header className="bg-white shadow-sm border-b border-gray-200">
                <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
                    <div className="flex justify-between items-center h-14 sm:h-16">
                        <div className="flex items-center min-w-0 flex-1">
                            <img src="/img/3h.png" alt="Logo" className="w-8 h-8 sm:w-10 sm:h-10 mr-2 sm:mr-3 flex-shrink-0" />
                            <h1 className="text-base sm:text-xl font-bold text-gray-900 truncate">SCVČ Tri Hôrky</h1>
                        </div>
                        <nav className="flex space-x-2 sm:space-x-4 flex-shrink-0">
                            <a href="/" className="text-xs sm:text-sm text-gray-600 hover:text-gray-900 transition-colors">
                                Domov
                            </a>
                        </nav>
                    </div>
                </div>
            </header>

            <div className="flex items-center justify-center py-6 sm:py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-md w-full space-y-6 sm:space-y-8">
                    {status === 'email' && (
                        <div className="bg-white shadow-lg rounded-lg p-6 sm:p-8">
                            <div className="text-center mb-4 sm:mb-6">
                                <div className="flex items-center justify-center h-12 w-12 sm:h-16 sm:w-16 rounded-full bg-blue-100 mx-auto mb-3 sm:mb-4">
                                    <IconMail className="h-6 w-6 sm:h-8 sm:w-8 text-blue-600" />
                                </div>
                                <h2 className="text-xl sm:text-2xl font-bold text-gray-900">
                                    Prihlásenie používateľa
                                </h2>
                                <p className="mt-2 text-xs sm:text-sm text-gray-600">
                                    Zadajte e-mail&nbsp;
                                    <span className="text-xs sm:text-sm text-gray-800 font-semibold underline">plnoletého člena</span>
                                    {" alebo "}
                                    <span className="text-xs sm:text-sm text-gray-800 font-semibold underline">{`zákonného zástupcu `}</span>
                                    a pošleme vám prihlasovací link. Tento e-mail bude použitý aj na prihlasovanie do Edupage.

                                </p>
                            </div>


                            <form onSubmit={onSubmit} className="space-y-4">
                                <div>
                                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                                        E-mailová adresa
                                    </label>
                                    <div className="relative">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <IconMail className="h-4 w-4 sm:h-5 sm:w-5 text-gray-400" />
                                        </div>
                                        <input
                                            id="email"
                                            name="email"
                                            type="email"
                                            autoComplete="email"
                                            required
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            className="pl-8 sm:pl-10 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm sm:text-base"
                                            placeholder="meno@email.com"
                                        />
                                    </div>
                                </div>

                                <button
                                    type="submit"
                                    disabled={pending}
                                    className="w-full flex justify-center py-2.5 sm:py-2 px-4 border border-transparent rounded-md shadow-sm text-xs sm:text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                                >
                                    {pending ? 'Odosielam...' : 'Poslať prihlasovací link'}
                                </button>

                                <p className="mt-1 text-xs sm:text-sm text-gray-500 text-center">
                                    Ak ste sa prihlasovali aj pred rokom, použite na prihlásenie rovnaký e-mail.
                                    V opačnom prípade nebude možné pridať osoby ktoré boli prihlásené minulý rok.
                                </p>
                            </form>
                        </div>
                    )}

                    {status === 'confirm' && (
                        <div className="bg-white shadow-lg rounded-lg p-8">
                            <div className="text-center">
                                <div className="flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mx-auto mb-4">
                                    <IconCheck className="h-8 w-8 text-green-600" />
                                </div>
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                    E-mail odoslaný!
                                </h2>
                                <p className="text-gray-600 mb-2">
                                    Na adresu <span className="font-medium text-blue-600">{email}</span> sme zaslali link na prihlásenie.
                                </p>
                                <p className="text-sm text-gray-500 mb-6">
                                    Skontrolujte si doručenú poštu a kliknite na link pre pokračovanie.
                                </p>

                                <button
                                    onClick={() => setStatus('email')}
                                    className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                                >
                                    <IconArrowLeft className="h-4 w-4 mr-2" />
                                    Zadať iný e-mail
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}